const initialState = {
  VerificationDialogPopup: {
    isDropDownCall: false,
    isStatusTag: '',
    checkAdmValue: false,
    intMedValue: 0,
    intMedId: 0,
    isTmtStsId: 0,
    isCallVerifyPopup: false,
    isValidateP3Call: false,
    isCallApi: false,
    verPrtId: '',
    verIcnCDC: '',
    verEpdId: '',
    verSapAthId: '',
    verSapAthMaxUnits: '',
    verSapAthMaxWkUnits: '',
    i1TmtTmtStsId: '',
    i2TmtTmtStsId: '',
    i3TmtTmtStsId: '',
    i4TmtTmtStsId: '',
    i5TmtTmtStsId: '',
    i6TmtTmtStsId: '',
    i7TmtTmtStsId: '',
    g1TmtTmtStsId: '',
    g2TmtTmtStsId: '',
    g3TmtTmtStsId: '',
    g4TmtTmtStsId: '',
    g5TmtTmtStsId: '',
    g6TmtTmtStsId: '',
    g7TmtTmtStsId: '',
    d1TmtTmtStsId: '',
    d2TmtTmtStsId: '',
    d3TmtTmtStsId: '',
    d4TmtTmtStsId: '',
    d5TmtTmtStsId: '',
    d6TmtTmtStsId: '',
    d7TmtTmtStsId: '',
    faceTimei1: '',
    faceTimei2: '',
    faceTimei3: '',
    faceTimei4: '',
    faceTimei5: '',
    faceTimei6: '',
    faceTimei7: '',
    supplementalTimei1: '',
    supplementalTimei2: '',
    supplementalTimei3: '',
    supplementalTimei4: '',
    supplementalTimei5: '',
    supplementalTimei6: '',
    supplementalTimei7: '',
    i1TmtFaceHours: '',
    i2TmtFaceHours: '',
    i3TmtFaceHours: '',
    i4TmtFaceHours: '',
    i5TmtFaceHours: '',
    i6TmtFaceHours: '',
    i7TmtFaceHours: '',
    i1TmtFaceMins: '',
    i2TmtFaceMins: '',
    i3TmtFaceMins: '',
    i4TmtFaceMins: '',
    i5TmtFaceMins: '',
    i6TmtFaceMins: '',
    i7TmtFaceMins: '',
    i1TmtSuppHours: '',
    i2TmtSuppHours: '',
    i3TmtSuppHours: '',
    i4TmtSuppHours: '',
    i5TmtSuppHours: '',
    i6TmtSuppHours: '',
    i7TmtSuppHours: '',
    i1TmtSuppMins: '',
    i2TmtSuppMins: '',
    i3TmtSuppMins: '',
    i4TmtSuppMins: '',
    i5TmtSuppMins: '',
    i6TmtSuppMins: '',
    i7TmtSuppMins: '',
  },
};

export default initialState;
